module.exports = __webpack_public_path__ + "static/img/img-ptfw4x.8df68e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-ptfw4x.png
// module id = ZUV8
// module chunks = 0